import Color from "color";

import { colors } from "@apps/viewer/src/ts/config";

/**
 * Collection of shared configurations within the header.
 */
export const config = {
    /**
     * Generate backdrop color by fading the default white color out slightly.
     */
    backdropColor: Color(colors.white)
        .alpha(0.8)
        .toString(),

    /**
     * Generate the color of the drop shadow by fading the default black color
     * out slightly.
     */
    dropShadowColor: Color(colors.black)
        .alpha(0.25)
        .toString(),
};
